import type {AiPromptBox, AiPromptBoxReduxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {AiPromptBoxSendPhase, AiPromptBoxSize, PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {getInFlightPendingAttachments} from '@Components/ai-prompt-box/libraries/ai-prompt-box-pending-uploads.library';

export const aiPromptBoxInitialState = (): AiPromptBoxReduxState => {
  return {};
};

export const isPromptBoxProcessing = (state: PromptBoxState): boolean => {
  return state === PromptBoxState.LOADING || state === PromptBoxState.STOPPABLE_LOADING;
};

export const getAiPromptBoxSendPhase = (state: AiPromptBox): AiPromptBoxSendPhase => {
  if (state.isFinishingUploads) {
    return AiPromptBoxSendPhase.SOFT_SENDING;
  }
  if (isPromptBoxProcessing(state.promptBoxState)) {
    return AiPromptBoxSendPhase.HARD_SENDING;
  }
  return AiPromptBoxSendPhase.IDLE;
};

export const isInAnySendPhase = (phase: AiPromptBoxSendPhase): boolean => {
  return phase !== AiPromptBoxSendPhase.IDLE;
};

export const hasActiveAttachmentLoaders = (attachmentLoaders?: AiPromptBox['attachmentLoaders']): boolean => {
  return !!attachmentLoaders && attachmentLoaders.length > 0;
};

export const isAnyAttachmentUploading = (state: AiPromptBox): boolean => {
  return hasActiveAttachmentLoaders(state.attachmentLoaders) || getInFlightPendingAttachments(state.attachments?.items).length > 0;
};

export const getDefaultAiPromptBoxState = (isMobile = false): AiPromptBox => {
  return {
    prompt: '',
    placeholder: '',
    size: AiPromptBoxSize.MEDIUM,
    promptBoxState: PromptBoxState.IDLE,
    showInitialAnimation: true,
    pinnedAspectRatio: null,
    pinnedBrandKitId: null,
    transcription: {
      showMic: false,
      permissionDenied: false,
      visualizerBarWidth: isMobile ? 2 : 3,
      visualizerGap: isMobile ? 3 : 2,
      visualizerFramesPerBar: isMobile ? 18 : 12,
    },
  };
};
